'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Spinner } from '@common/components';
import { cn } from '@core/utils';
import { useState } from 'react';
interface CommentFormProps {
  onSubmit?: (comment: string) => void;
  onChange?: (comment?: string) => void;
  onClose?: () => void;
  loading?: boolean;
  isEdit?: boolean;
  initialComment?: string;
}
export const CommentForm = t0 => {
  const $ = _c(35);
  const {
    onSubmit,
    onChange,
    onClose,
    loading,
    isEdit,
    initialComment
  } = t0;
  const [comment, setComment] = useState(initialComment ?? "");
  let t1;
  if ($[0] !== comment || $[1] !== loading || $[2] !== onSubmit) {
    t1 = () => {
      if (loading) {
        return;
      }
      setComment("");
      onSubmit?.(comment);
    };
    $[0] = comment;
    $[1] = loading;
    $[2] = onSubmit;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSubmit = t1;
  let t2;
  if ($[4] !== onChange) {
    t2 = e => {
      if (e.target.value.length > 100) {
        return;
      }
      setComment(e.target.value);
      onChange?.(e.target.value);
    };
    $[4] = onChange;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleChange = t2;
  let t3;
  if ($[6] !== comment) {
    t3 = comment.trim();
    $[6] = comment;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const isDisabledSubmitButton = !t3;
  const submitButtonText = isEdit ? "\uC218\uC815" : "\uB4F1\uB85D";
  const isShowCancelButton = isEdit;
  let t4;
  if ($[8] !== loading) {
    t4 = cn("relative flex w-full flex-col gap-8 rounded-small border border-Gray-300 px-16 py-12", {
      "pointer-events-none blur-sm": loading
    });
    $[8] = loading;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== comment || $[11] !== handleChange) {
    t5 = <textarea className="min-h-80 resize-none text-Gray-900 outline-none placeholder:font-400 placeholder:text-Gray-550 placeholder:typo-body3" placeholder={"\uC751\uC6D0\uC758 \uB9D0\uC744 \uB0A8\uACA8\uC8FC\uC138\uC694"} value={comment} onChange={handleChange} maxLength={100} />;
    $[10] = comment;
    $[11] = handleChange;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== comment.length) {
    t6 = <p className="font-400 text-Gray-550 typo-caption1">{comment.length}/100</p>;
    $[13] = comment.length;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== isShowCancelButton || $[16] !== onClose) {
    t7 = isShowCancelButton && <Button theme="sub-fill" dimensions="H32" onClick={() => onClose?.()}>취소</Button>;
    $[15] = isShowCancelButton;
    $[16] = onClose;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== handleSubmit || $[19] !== isDisabledSubmitButton || $[20] !== submitButtonText) {
    t8 = <Button dimensions="H32" disabled={isDisabledSubmitButton} onClick={handleSubmit}>{submitButtonText}</Button>;
    $[18] = handleSubmit;
    $[19] = isDisabledSubmitButton;
    $[20] = submitButtonText;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t7 || $[23] !== t8) {
    t9 = <div className="flex items-center gap-4">{t7}{t8}</div>;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t6 || $[26] !== t9) {
    t10 = <div className="flex items-end justify-between">{t6}{t9}</div>;
    $[25] = t6;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== loading) {
    t11 = loading && <div className="absolute left-0 top-0 size-full bg-Gray-white/10 flex-center"><Spinner /></div>;
    $[28] = loading;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t10 || $[31] !== t11 || $[32] !== t4 || $[33] !== t5) {
    t12 = <article className={t4}>{t5}{t10}{t11}</article>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t4;
    $[33] = t5;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
};